import { server } from "../../server";
import { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import { getCurrentTime } from "../../functions";
import {
  classList,
  departmentList,
  designationList,
  houseList,
  sectionList,
} from "../../utils";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import CustomMultiSelect from "../../components/CustomMultiSelect";

function SendSMS() {
  const [noticeBoard, setNoticeBoard] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [smsTemplate, setSMSTemplate] = useState([]);
  const [variableValues, setVariableValues] = useState([]);
  const recordsPerPage = 10;
  const [templateOptions, setTemplateOptions] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  useEffect(() => {
    if (smsTemplate.length > 0) {
      const options = smsTemplate.map((item) => ({
        label: item.templateName,
        value: item.templateId,
      }));
      setTemplateOptions(options);
    }
  }, [smsTemplate]);

  const [formData, setFormData] = useState({
    templateId: "",
    smsTemplate: "",
    message: "",
    category: "All",
    studentFilter: {
      studentClass: [],
      section: [],
      gender: [],
      house: [],
      busNo: [],
    },
    staffFilter: {
      staffCategory: [],
      designation: [],
      department: [],
      gender: [],
    },
  });

  const allClassOptions = classList.map((item) => ({
    value: item,
    label: item,
  }));
  const allSectionOptions = sectionList.map((item) => ({
    value: item,
    label: item,
  }));
  const allBusNoOptions = Array.from({ length: 40 }, (_, i) => ({
    value: (i + 1).toString().padStart(2, "0"),
    label: (i + 1).toString().padStart(2, "0"),
  }));
  const allHouseOptions = houseList.map((item) => ({
    value: item,
    label: item,
  }));
  const allGenderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
  ];
  const allDesignationOptions = designationList.map((item) => ({
    value: item,
    label: item,
  }));
  const allDepartmentOptions = departmentList.map((item) => ({
    value: item,
    label: item,
  }));

  const withSelectAll = (options) => [
    { value: "*", label: "Select All" },
    ...options,
  ];

  const staffCategoryOptions = [
    { label: "Teaching", value: "Teaching" },
    { label: "Non Teaching", value: "Non Teaching" },
    { label: "Supporting Staff", value: "Supporting Staff" },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleMultiSelectChange = (selected, keyPath) => {
    const isSelectAll = selected?.some((s) => s.value === "*");

    let newSelected = selected || [];

    if (isSelectAll) {
      const actualOptions =
        keyPath[1] === "designation"
          ? allDesignationOptions
          : keyPath[1] === "department"
            ? allDepartmentOptions
            : keyPath[1] === "studentClass"
              ? allClassOptions
              : keyPath[1] === "section"
                ? allSectionOptions
                : keyPath[1] === "busNo"
                  ? allBusNoOptions
                  : keyPath[1] === "house"
                    ? allHouseOptions
                    : keyPath[1] === "gender"
                      ? allGenderOptions
                      : [];

      newSelected = actualOptions;
    }

    const values = newSelected.map((s) => s.value);

    setFormData((prev) => {
      const updated = { ...prev };
      if (keyPath.length === 2) {
        updated[keyPath[0]] = {
          ...prev[keyPath[0]],
          [keyPath[1]]: values,
        };
      } else {
        updated[keyPath[0]] = values;
      }
      return updated;
    });
  };

  const getSelectedOptions = (allOptions, selectedValues) => {
    return allOptions.filter((opt) => selectedValues.includes(opt.value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.smsTemplate) {
      toast.error("Message Required", { position: "top-right" });
      return;
    }

    try {
      const payload = {
        templateId: formData.templateId,
        smsTemplate: formData.message,
        category: formData.category,
        studentFilter: {
          studentClass: formData.studentFilter.studentClass,
          section: formData.studentFilter.section,
          gender: formData.studentFilter.gender,
          house: formData.studentFilter.house,
          busNo: formData.studentFilter.busNo,
        },
        staffFilter: {
          staffCategory: formData.staffFilter.staffCategory,
          designation: formData.staffFilter.designation,
          department: formData.staffFilter.department,
          gender: formData.staffFilter.gender,
        },
      };

      // await axios.post(`${server}create_sms_mongodb_new`, payload);
      toast.success("SMS Sent", { position: "top-right" });

      // Reset form
      setFormData({
        templateId: "",
        smsTemplate: "",
        category: "All",
        studentFilter: {
          studentClass: [],
          section: [],
          gender: [],
          house: [],
          busNo: [],
        },
        staffFilter: {
          staffCategory: [],
          designation: [],
          department: [],
          gender: [],
        },
      });
    } catch (error) {
      console.error(error);
      toast.error("Please Try Again", { position: "top-right" });
    }
  };

  const fetchNotice = async () => {
    try {
      const response = await axios.get(`${server}/sms_get_all_mongodb`, {
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
        },
      });
      if (response.data && response.data["body-json"]?.body?.emails) {
        setNoticeBoard(response.data["body-json"].body.emails);
      } else {
        console.error("Invalid data format from API", response.data);
      }
    } catch (error) {
      console.error("Error fetching bus details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotice();
  }, []);

  const fetchSMSTemplate = async () => {
    try {
      const response = await axios.post(
        `${server}/sms_template_getbydate_and_getall_mongodb`,
        {},
        {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
          },
        },
      );
      if (response.data && response.data["body-json"]?.body?.templates) {
        setSMSTemplate(response.data["body-json"].body.templates);
      } else {
        console.error("Invalid data format from API", response.data);
      }
    } catch (error) {
      console.error("Error fetching bus details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSMSTemplate();
  }, []);

  // Filter
  const filteredRecords = noticeBoard.filter((scholarship) => {
    const searchLower = searchTerm.toLowerCase();

    return Object.values(scholarship).some((value) => {
      if (typeof value === "string") {
        return value.toLowerCase().includes(searchLower);
      } else if (typeof value === "object" && value !== null) {
        return Object.values(value).some(
          (subValue) =>
            typeof subValue === "string" &&
            subValue.toLowerCase().includes(searchLower),
        );
      }
      return false;
    });
  });

  // ✅ Reset pagination when searching
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  // ✅ Apply pagination AFTER filtering
  const totalPages = Math.ceil(filteredRecords.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredRecords.slice(
    indexOfFirstRecord,
    indexOfLastRecord,
  );

  // Page Navigation
  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleExportAllSMSExcel = () => {
    if (!noticeBoard || noticeBoard.length === 0) {
      toast.error("No SMS records to export.");
      return;
    }

    const sheetData = noticeBoard.map((sms) => ({
      "Template ID": sms.templateId || "",
      Title: sms.title || "",
      Class: sms.class || "",
      Section: sms.section || "",
      "Bus No": sms.busNo || "",
      House: sms.house || "",
      Gender: sms.gender || "",
      Message: sms.message || "",
      Date: sms.createdAt
        ? new Date(sms.createdAt).toLocaleDateString("en-GB")
        : "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "All SMS");

    const today = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(workbook, `AllSMS_${today}.xlsx`);
    toast.success("Report Generated");
  };

  const handleExportSMSTemplateWiseExcel = () => {
    if (!noticeBoard || noticeBoard.length === 0) {
      toast.error("No SMS records to export.");
      return;
    }

    const templateGroups = {};
    noticeBoard.forEach((sms) => {
      const templateId = sms.templateId || "Unknown_Template";
      if (!templateGroups[templateId]) {
        templateGroups[templateId] = [];
      }
      templateGroups[templateId].push(sms);
    });

    const workbook = XLSX.utils.book_new();

    Object.entries(templateGroups).forEach(([templateId, smsList]) => {
      const sheetData = smsList.map((sms) => ({
        "Template ID": sms.templateId || "",
        Title: sms.title || "",
        Class: sms.class || "",
        Section: sms.section || "",
        "Bus No": sms.busNo || "",
        House: sms.house || "",
        Gender: sms.gender || "",
        Message: sms.message || "",
        Date: sms.createdAt
          ? new Date(sms.createdAt).toLocaleDateString("en-GB")
          : "",
      }));

      const worksheet = XLSX.utils.json_to_sheet(sheetData);

      const sheetName = `${templateId}`.substring(0, 31);
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    });

    const today = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(workbook, `SMS_TemplateWise_${today}.xlsx`);
    toast.success("Report Generated");
  };

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div
            class="modal fade gd-example-modal-lg"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myLargeModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-xl">
              <div class="modal-content">
                <form onSubmit={handleSubmit}>
                  <div className="modal-header d-flex justify-content-between">
                    <h5
                      className="modal-title fs-4"
                      id="exampleModalToggleLabel"
                    >
                      Compose SMS
                    </h5>
                    <div className="d-flex align-items-center">
                      <span className="badge bg-success-soft me-3 px-3">
                        Editable
                      </span>
                      <div className="form-check form-switch me-4">
                        <input
                          type="checkbox"
                          className="form-check-input m-0"
                          checked
                          readOnly
                        />
                      </div>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                  </div>

                  <div className="modal-body pb-0">
                    <div className="row g-2 pb-4">
                      <div className="col-8">
                        <div className="row g-2">
                          <div className="col-lg-6 col-12">
                            <label className="form-label mb-1 ms-3">
                              Template <span className="text-danger">*</span>
                            </label>
                            <Select
                              options={templateOptions}
                              value={selectedTemplate}
                              onChange={(selected) => {
                                setSelectedTemplate(selected);
                                if (selected) {
                                  const template = smsTemplate.find(
                                    (t) => t.templateId === selected.value,
                                  );

                                  if (template) {
                                    setVariableValues(
                                      Array(template.variables).fill(""),
                                    );
                                    setFormData((prev) => ({
                                      ...prev,
                                      smsTemplate: template.message,
                                      message: template.message,
                                      templateId: selected.value,
                                    }));
                                  }
                                } else {
                                  setVariableValues([]);
                                  setFormData((prev) => ({
                                    ...prev,
                                    smsTemplate: "",
                                    message: "",
                                    templateId: "",
                                  }));
                                }
                              }}
                              isClearable
                              placeholder="Select Template"
                            />
                          </div>

                          {variableValues.map((val, index) => (
                            <div key={index} className="col-lg-6 col-12">
                              <label className="form-label mb-1 ms-3">
                                {`Variable (${index + 1})`}{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder={`Enter Value`}
                                value={val}
                                onChange={(e) => {
                                  const newValues = [...variableValues];
                                  newValues[index] = e.target.value;
                                  setVariableValues(newValues);

                                  const template = smsTemplate.find(
                                    (t) =>
                                      t.templateId === selectedTemplate?.value,
                                  );
                                  if (template) {
                                    let finalMessage = template.message;
                                    newValues.forEach((v, i) => {
                                      const regex = new RegExp(
                                        `##VAR${i + 1}##`,
                                        "g",
                                      );
                                      finalMessage = finalMessage.replace(
                                        regex,
                                        v || `##VAR${i + 1}##`,
                                      );
                                    });
                                    setFormData((prev) => ({
                                      ...prev,
                                      message: finalMessage,
                                    }));
                                  }
                                }}
                              />
                            </div>
                          ))}

                          {/* Category */}
                          <div className="col-lg-6 col-12">
                            <label className="form-label mb-1 ms-3">
                              Category <span className="text-danger">*</span>
                            </label>
                            <Select
                              options={[
                                { label: "All", value: "All" },
                                { label: "Student", value: "Student" },
                                { label: "Staff", value: "Staff" },
                              ]}
                              value={{
                                label: formData.category,
                                value: formData.category,
                              }}
                              onChange={(selected) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  category: selected?.value || "",
                                }))
                              }
                              placeholder="Select Category"
                            />
                          </div>

                          {/* Student Filters (Visible Only When Student Selected) */}
                          {formData.category === "Student" && (
                            <>
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Class
                                </label>
                                <CustomMultiSelect
                                  options={allClassOptions}
                                  withSelectAllFn={withSelectAll}
                                  value={getSelectedOptions(
                                    allClassOptions,
                                    formData.studentFilter.studentClass,
                                  )}
                                  handleMultiSelectChange={
                                    handleMultiSelectChange
                                  }
                                  path={["studentFilter", "studentClass"]}
                                  placeholder="Select Class"
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Section
                                </label>
                                <CustomMultiSelect
                                  options={allSectionOptions}
                                  withSelectAllFn={withSelectAll}
                                  value={getSelectedOptions(
                                    allSectionOptions,
                                    formData.studentFilter.section,
                                  )}
                                  handleMultiSelectChange={
                                    handleMultiSelectChange
                                  }
                                  path={["studentFilter", "section"]}
                                  placeholder="Select Section"
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Bus No
                                </label>
                                <CustomMultiSelect
                                  options={allBusNoOptions}
                                  withSelectAllFn={withSelectAll}
                                  value={getSelectedOptions(
                                    allBusNoOptions,
                                    formData.studentFilter.busNo,
                                  )}
                                  handleMultiSelectChange={
                                    handleMultiSelectChange
                                  }
                                  path={["studentFilter", "busNo"]}
                                  placeholder="Select Bus Number"
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  House
                                </label>
                                <CustomMultiSelect
                                  options={allHouseOptions}
                                  withSelectAllFn={withSelectAll}
                                  value={getSelectedOptions(
                                    allHouseOptions,
                                    formData.studentFilter.house,
                                  )}
                                  handleMultiSelectChange={
                                    handleMultiSelectChange
                                  }
                                  path={["studentFilter", "house"]}
                                  placeholder="Select House"
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Gender
                                </label>
                                <CustomMultiSelect
                                  options={allGenderOptions}
                                  withSelectAllFn={withSelectAll}
                                  value={getSelectedOptions(
                                    allGenderOptions,
                                    formData.studentFilter.gender,
                                  )}
                                  handleMultiSelectChange={
                                    handleMultiSelectChange
                                  }
                                  path={["studentFilter", "gender"]}
                                  placeholder="Select Gender"
                                />
                              </div>
                            </>
                          )}

                          {/* Staff Filters (Visible Only When Staff Selected) */}
                          {formData.category === "Staff" && (
                            <>
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Staff Category
                                </label>
                                <CustomMultiSelect
                                  options={staffCategoryOptions}
                                  withSelectAllFn={withSelectAll}
                                  value={getSelectedOptions(
                                    staffCategoryOptions,
                                    formData.staffFilter.staffCategory,
                                  )}
                                  handleMultiSelectChange={
                                    handleMultiSelectChange
                                  }
                                  path={["staffFilter", "staffCategory"]}
                                  placeholder="Select Staff Category"
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Designation
                                </label>
                                <CustomMultiSelect
                                  options={allDesignationOptions}
                                  withSelectAllFn={withSelectAll}
                                  value={getSelectedOptions(
                                    allDesignationOptions,
                                    formData.staffFilter.designation,
                                  )}
                                  handleMultiSelectChange={
                                    handleMultiSelectChange
                                  }
                                  path={["staffFilter", "designation"]}
                                  placeholder="Select Designation"
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Department
                                </label>
                                <CustomMultiSelect
                                  options={allDepartmentOptions}
                                  withSelectAllFn={withSelectAll}
                                  value={getSelectedOptions(
                                    allDepartmentOptions,
                                    formData.staffFilter.department,
                                  )}
                                  handleMultiSelectChange={
                                    handleMultiSelectChange
                                  }
                                  path={["staffFilter", "department"]}
                                  placeholder="Select Department"
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Gender
                                </label>
                                <CustomMultiSelect
                                  options={allGenderOptions}
                                  withSelectAllFn={withSelectAll}
                                  value={getSelectedOptions(
                                    allGenderOptions,
                                    formData.staffFilter.gender,
                                  )}
                                  handleMultiSelectChange={
                                    handleMultiSelectChange
                                  }
                                  path={["staffFilter", "gender"]}
                                  placeholder="Select Gender"
                                />
                              </div>
                            </>
                          )}
                        </div>

                        <div className="alert alert-warning mt-3 lh-sm rounded-4 mt-5 px-4">
                          <strong className="fw-semibold">Note &mdash;</strong>{" "}
                          Once the SMS is submitted, it will be sent to{" "}
                          <strong className="fw-semibold">
                            all recipients
                          </strong>{" "}
                          and{" "}
                          <strong className="fw-semibold">
                            cannot be undone / recalled
                          </strong>
                          . Please{" "}
                          <strong className="fw-semibold">
                            review and confirm
                          </strong>{" "}
                          all details carefully before clicking{" "}
                          <strong className="fw-semibold">Submit</strong>.
                        </div>

                        <div className="mt-5">
                          <button
                            type="button"
                            className="btn btn-secondary px-3 me-1 rounded-pill"
                            data-bs-dismiss="modal"
                          >
                            <i className="bi bi-x-lg"></i>
                          </button>
                          <button
                            type="submit"
                            class="btn btn-primary px-5 rounded-pill fw-normal"
                            disabled={loading}
                          >
                            {loading ? (
                              <div
                                class="spinner-border spinner-border-sm"
                                role="status"
                              ></div>
                            ) : (
                              "Submit"
                            )}
                          </button>
                        </div>
                      </div>

                      <div className="col-4 px-7">
                        <div className="position-relative d-flex">
                          <img
                            src="/assets/images/phone.jpg"
                            className="w-100 object-fit-cover"
                            draggable="false"
                          />
                          <div className="position-absolute px-4 py-8 mt-2">
                            <h4 className="text-center m-0 fs-5 lh-sm fw-medium text-white">
                              CP-AHRKLM-S
                            </h4>
                            <p className="text-center text-secondary fs-5 mt-0 lh-1">
                              {getCurrentTime()}
                            </p>
                            <div className="p-2">
                              {formData.message ? (
                                <p
                                  className="lh-sm ls-sm text-white m-0 fs-6 opacity-75"
                                  dangerouslySetInnerHTML={{
                                    __html: (formData.message || "")
                                      .replace(/\\r\\n|\\n|\\r/g, "\n")
                                      .replace(/\n/g, "<br />"),
                                  }}
                                />
                              ) : (
                                <p className="lh-sm ls-sm text-white m-0 fs-6 opacity-75">
                                  <i className="text-white">
                                    Acharyakulam built-in SMS preview
                                  </i>
                                  <br />
                                  <br />
                                  Select a template and fill in the variables
                                  below to generate a preview of the SMS that
                                  will be sent to the recipient.
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="">
            <div class="container-fluid my-3 px-3">
              <div className="row g-2">
                <div className="col-lg-8">
                  <div class="table-responsive border-0 overflow-y-hidden bg-white rounded-4">
                    <table class="table mb-0 text-nowrap table-centered">
                      <thead class="table-light">
                        <tr>
                          <th className="w-10">No.</th>
                          <th className="lh-1 w-60">
                            Details
                            <i className="bi bi-info-circle ms-2 text-dark"></i>
                            <br />
                            <span className="fs-8 fw-normal text-secondary">
                              Displaying Information as per Record
                            </span>
                          </th>
                          <th className="lh-1 w-30">
                            Action
                            <i className="bi bi-person-gear ms-2 text-dark"></i>
                            <br />
                            <span className="fs-8 fw-normal text-secondary">
                              Role-Specific Action Panel
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentRecords.map((sms, index) => (
                          <tr>
                            <td>{indexOfFirstRecord + index + 1}.</td>
                            <td className="lh-sm py-4 text-wrap">
                              <span class="text-dark">Template Id</span> &mdash;{" "}
                              {sms.templateId}
                              <br />
                              <span class="text-dark">Title</span> &mdash;{" "}
                              {sms.title}
                              <br />
                              <span class="text-dark">Class</span> &mdash;{" "}
                              {sms.class}
                              <br />
                              <span class="text-dark">
                                Section
                              </span> &mdash; {sms.section}
                              <br />
                              <span class="text-dark">Bus No</span> &mdash;{" "}
                              {sms.busNo}
                              <br />
                              <span class="text-dark">House</span> &mdash;{" "}
                              {sms.house}
                              <br />
                              <span class="text-dark">Gender</span> &mdash;{" "}
                              {sms.gender}
                              <br />
                              <span class="text-dark">
                                Message
                              </span> &mdash;{" "}
                              {sms.message
                                .split(" ")
                                .reduce((acc, word, index) => {
                                  const last = acc.length - 1;
                                  if (index % 5 === 0) {
                                    acc.push([word]);
                                  } else {
                                    acc[last].push(word);
                                  }
                                  return acc;
                                }, [])
                                .map((group, i) => (
                                  <span key={i}>
                                    {group.join(" ")}
                                    <br />
                                  </span>
                                ))}
                              <br />
                              <span class="text-dark">Date</span> &mdash;{" "}
                              {sms.createdAt
                                ? new Date(sms.createdAt).toLocaleDateString(
                                    "en-GB",
                                  )
                                : ""}
                            </td>
                            <td>
                              <div className="d-flex flex-column gap-1 width-fit-content">
                                <span class="badge bg-success-soft cursor-pointer px-4 rounded-3 btn-py-sm">
                                  SMS Sent
                                </span>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="col-lg-4">
                  <div class="">
                    <div className="mb-3">
                      <div className="d-flex bg-white justify-content-between rounded-4">
                        <form
                          className="d-flex align-items-center"
                          onSubmit={(e) => e.preventDefault()}
                        >
                          <span className="position-absolute ps-3 search-icon">
                            <i className="bi bi-filter-circle-fill ms-1" />
                          </span>
                          <input
                            type="search"
                            className="form-control ps-7 rounded-3 border-0 rounded-4"
                            placeholder="Filter Data"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </form>
                        <Link
                          data-bs-toggle="modal"
                          data-bs-target=".gd-example-modal-lg"
                          class="btn btn-warning px-5 fs-6 fw-medium rounded-4 fit-content"
                        >
                          Compose SMS
                        </Link>
                      </div>
                      <div className="mt-2 ms-4">
                        <nav aria-label="breadcrumb">
                          <ol class="breadcrumb pe-3">
                            <li class="breadcrumb-item">
                              <a href="#">Communicate</a>
                            </li>
                            <li
                              class="breadcrumb-item active"
                              aria-current="page"
                            >
                              Send SMS
                            </li>
                          </ol>
                        </nav>
                      </div>
                    </div>

                    <div className="p-4 bg-white rounded-4">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                          {loading ? (
                            <div
                              className="spinner-border text-dark data-loader-spinner"
                              role="status"
                            ></div>
                          ) : (
                            <img src="/assets/images/folder.svg" />
                          )}

                          <p className="my-0 fw-semibold lh-1 fs-5 text-dark mx-3">
                            Send SMS
                            <br />
                            <span className="text-secondary fs-6 fw-medium lh-sm">
                              0.2 MB Size
                            </span>
                          </p>
                        </div>
                        <span className="badge bg-pink rounded-3 px-4 py-2 me-1 mt-1 cursor-pointer">
                          Export
                        </span>
                      </div>

                      <div class="px-4 py-2 mt-3 bg-light rounded-4">
                        <li className="list-group-item px-0">
                          <a
                            className="d-flex align-items-center text-inherit mb-0 justify-content-between"
                            data-bs-toggle="collapse"
                            href="#specifications"
                            role="button"
                            aria-expanded="false"
                            aria-controls="specifications"
                          >
                            <p className="m-0 fw-medium lh-sm text-dark">
                              Download Report
                            </p>
                            <span className="chevron-arrow ms-4">
                              <i className="bi bi-chevron-down fs-4" />
                            </span>
                          </a>
                          <div
                            className="collapse"
                            id="specifications"
                            data-bs-parent="#ecommerceAccordion"
                          >
                            <div className="py-3">
                              <div class="rounded-4 d-flex flex-wrap">
                                <span
                                  onClick={handleExportAllSMSExcel}
                                  class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1"
                                >
                                  All SMS
                                </span>
                                <span
                                  onClick={handleExportSMSTemplateWiseExcel}
                                  class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1"
                                >
                                  Template Wise
                                </span>
                                <span class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1">
                                  Date Wise SMS
                                </span>
                              </div>
                            </div>
                          </div>
                        </li>
                      </div>
                    </div>

                    <div className="my-4">
                      <nav>
                        <ul className="pagination justify-content-center mb-0">
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button className="page-link" onClick={prevPage}>
                              <i className="bi bi-chevron-left"></i>
                            </button>
                          </li>

                          {(() => {
                            const pageNumbers = [];
                            pageNumbers.push(1);

                            if (currentPage > 3) {
                              pageNumbers.push("left-ellipsis");
                            }

                            if (
                              currentPage !== 1 &&
                              currentPage !== totalPages
                            ) {
                              pageNumbers.push(currentPage);
                            }

                            if (currentPage < totalPages - 2) {
                              pageNumbers.push("right-ellipsis");
                            }

                            if (totalPages > 1) {
                              pageNumbers.push(totalPages);
                            }

                            return pageNumbers.map((page, index) => {
                              if (
                                page === "left-ellipsis" ||
                                page === "right-ellipsis"
                              ) {
                                return (
                                  <li
                                    key={index}
                                    className="page-item disabled"
                                  >
                                    <span className="page-link">...</span>
                                  </li>
                                );
                              }

                              return (
                                <li
                                  key={index}
                                  className={`page-item ${
                                    currentPage === page ? "active" : ""
                                  }`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() => setCurrentPage(page)}
                                  >
                                    {page}
                                  </button>
                                </li>
                              );
                            });
                          })()}

                          <li
                            className={`page-item ${
                              currentPage === totalPages ? "disabled" : ""
                            }`}
                          >
                            <button className="page-link" onClick={nextPage}>
                              <i className="bi bi-chevron-right"></i>
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default SendSMS;
